module.exports = __webpack_public_path__ + "4e88609fe624dbea21267d9b6212ab48.svg";